import { Environment } from '../../enums';
import { RootState } from '../models';

export const selectEnvironment = (state: RootState) => {
  return state.data.isLoaded ? state.data.environment : Environment.Production;
};